import requestAction from '../../utils/requestAction'

export const fetchProductGroups = (params: string = "") =>
  requestAction('PRODUCTGROUP_LIST', params)(`productGroups`, 'GET')

export const fetchAllProductGroups = () =>
  fetchProductGroups('?all=true')